import { useLang } from "@/context/LanguageContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function WhatsNewDialog({ open, onOpenChange, releases }) {
  const { lang, t } = useLang();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t("whatsnew.title")}</DialogTitle>
        </DialogHeader>
        {releases.length === 0 && (
          <p className="text-sm text-slate-500 dark:text-slate-400">{t("whatsnew.empty")}</p>
        )}
        <div className="space-y-5">
          {releases.map(r => (
            <section key={r.version}>
              <h3 className="text-sm font-bold text-slate-900 dark:text-slate-100">
                v{r.version}
                <span className="ml-2 text-xs font-normal text-slate-500 dark:text-slate-400">{r.date}</span>
              </h3>
              <ul className="mt-1.5 space-y-1 list-disc pl-5 text-sm text-slate-700 dark:text-slate-300">
                {r.notes.map((n, i) => <li key={i}>{lang === "tr" ? n.tr : n.en}</li>)}
              </ul>
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
